import { render, staticRenderFns } from "./sup-deposit-vega.vue?vue&type=template&id=0d501dc1"
import script from "./sup-deposit-vega.vue?vue&type=script&lang=js"
export * from "./sup-deposit-vega.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports